export function OutlineGearIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4976 4H7.4976L3 11.7952L7.4976 19.5856H16.4976L21 11.7952L16.4976 4Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.7949C13.6569 14.7949 15 13.4518 15 11.7949C15 10.1381 13.6569 8.79492 12 8.79492C10.3431 8.79492 9 10.1381 9 11.7949C9 13.4518 10.3431 14.7949 12 14.7949Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
